import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import AccountReceiveable from "../../../containers/modules/report/account-receiveable";

export default function AccountReceiveableRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="account-receiveable"
      index
      element={
        <AccessControl
          name={"Account Receiveable Show"}
          auth={authUser}
          component={() => <AccountReceiveable />}
        />
      }
    ></Route>
  );
}
